// extracted by mini-css-extract-plugin
export var aboutImage = "AboutImage-module--aboutImage--4921f";